module.exports = __webpack_public_path__ + "img/q_60_sor.f73cd332.png";